// @flow
import * as React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import messages from './messages';
import { item } from '../shared/styles';

const MAX_DESCRIPTION_SIZE = 60;

type Props = {
  year?: number,
  doors?: number,
  mileage?: number,
  description?: string,
};

function getShortDescription(description: ?string): string {
  if (typeof description !== 'string') {
    return '';
  }

  const shortDescription = description.slice(0, MAX_DESCRIPTION_SIZE);
  return `${shortDescription.slice(0, shortDescription.lastIndexOf(' '))}...`;
}

export default function FeaturesCars({ year, doors, mileage, description }: Props): React.Node {
  if (!year && !doors && !mileage) {
    return (
      <React.Fragment>
        <li className="description-container">
          <span itemProp="description" className="description">
            {getShortDescription(description)}
          </span>
        </li>
        <style jsx>{item}</style>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {mileage && (
        <li>
          <span itemProp="mileageFromOdometer" className="value">
            <FormattedNumber value={mileage} />
          </span>
          <span className="name">
            <FormattedMessage {...messages.mileageAbrev} />
          </span>
        </li>
      )}
      {year && (
        <li>
          <span className="value">{year}</span>
          <span className="name">
            <FormattedMessage {...messages.yearAbrev} />
          </span>
        </li>
      )}
      {doors && (
        <li>
          <span itemProp="numberOfDoors" className="value">
            {doors}
          </span>
          <span className="name">
            <FormattedMessage {...messages.doorsAbrev} />
          </span>
        </li>
      )}
      <style jsx>{item}</style>
    </React.Fragment>
  );
}

FeaturesCars.defaultProps = {
  mileage: null,
  doors: null,
  year: null,
  description: null,
};



// WEBPACK FOOTER //
// ./app/components/mobile/Features/cars/index.js